import type { OrderInvoiceFields, OrderInvoiceItem, OrderInvoicePayload } from '@ts-orders/interfaces'

const ITEM_LABEL_SEPARATOR = ' · '

const toNullable = (value: string | null): string | null => {
  const trimmed = (value ?? '').trim()

  return trimmed || null
}

export const toInvoicePayload = (fields: OrderInvoiceFields): OrderInvoicePayload => ({
  parent_full_name: toNullable(fields.parent_full_name),
  address: toNullable(fields.address),
  items: fields.items.map(item => ({
    order_item_id: item.order_item_id,
    details: toNullable(item.details),
  })),
})

export const isInvoiceFieldsEmpty = (fields: OrderInvoiceFields): boolean => {
  const payload = toInvoicePayload(fields)

  return payload.parent_full_name === null
    && payload.address === null
    && payload.items.every(item => item.details === null)
}

export const areInvoiceFieldsEqual = (a: OrderInvoiceFields, b: OrderInvoiceFields): boolean =>
  JSON.stringify(toInvoicePayload(a)) === JSON.stringify(toInvoicePayload(b))

export const cloneInvoiceFields = (fields: OrderInvoiceFields): OrderInvoiceFields => ({
  parent_full_name: fields.parent_full_name,
  address: fields.address,
  items: fields.items.map(item => ({ ...item })),
})

export const getInvoiceItemLabel = (item: OrderInvoiceItem): string =>
  ['Details', item.product_name, item.kid_name].filter(Boolean).join(ITEM_LABEL_SEPARATOR)
